'use client';

import { InputField, RadioGroup } from '@prenuvo/halo-web';

import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { useShallow } from 'zustand/react/shallow';

import PhoneInputField from '../MemberInfoForm/PhoneInputField';
import { referralOptions } from './MedicalReferral.constants';
import { useEffect } from 'react';

const MedicalReferralSection = () => {
  const {
    isReferralRequired,
    medicalReferral,
    referrerName,
    referrerPhoneNumber,
    setMemberInfo,
    errorsPatientDetails,
    removeError,
  } = usePrenuvoStore(
    useShallow((state) => ({
      isReferralRequired: state?.scan.methods.isReferralRequired,
      medicalReferral: state.user.medicalReferral,
      referrerName: state.user.referrerName,
      referrerPhoneNumber: state.user.referrerPhoneNumber,
      setMemberInfo: state.user.methods.setMemberInfo,
      errorsPatientDetails: state.user.errors,
      removeError: state.user.methods.removeError,
    })),
  );

  const handleReferralChange = (value: string) => {
    if (!value) return;
    setMemberInfo({ medicalReferral: value });
    if (value === 'false') {
      setMemberInfo({ referrerName: undefined, referrerPhoneNumber: undefined });
    }
  };

  const handleReferralInputChanges = (field: string, value: any) => {
    removeError(field);
    setMemberInfo({ [field]: value });
  };

  useEffect(() => {
    const targetWords = ['recommended', 'already have'];
    const regex = new RegExp(`(${targetWords.join('|')})`, 'gi');

    document.querySelectorAll('label').forEach((label) => {
      label.innerHTML = label.innerHTML.replace(regex, '<span class="font-bold">$1</span>');
    });
  }, []);

  if (!isReferralRequired()) return null;

  return (
    <div className="rounded-2xl bg-neutral-50 px-4 pb-2 pt-6">
      <h2 className="mb-1 font-lato text-xl text-neutral-950">
        Appropriateness Review (US) / Medical Referral (Canada)
      </h2>
      <p className="mb-8">
        Because we are a clinical-quality MRI service, to have a test, we must perform an
        appropriateness review in the US or receive a medical referral in Canada.
      </p>
      <div className="my-4">
        <RadioGroup
          aria-label="medical referral"
          value={medicalReferral}
          options={referralOptions}
          onValueChange={handleReferralChange}
        />
      </div>
      {medicalReferral === 'true' && (
        <div className="flex flex-col gap-3 md:flex-row">
          <div className="w-full md:w-1/2">
            <InputField
              name="referrerName"
              placeholder={{
                children: `Provider's name`,
              }}
              size="lg"
              onChange={(e) => handleReferralInputChanges('referrerName', e.target.value)}
              isInvalid={!!errorsPatientDetails?.referrerName}
              caption={{
                translationKey: errorsPatientDetails?.referrerName,
              }}
              value={referrerName}
            />
          </div>
          <div className="w-full md:w-1/2">
            <PhoneInputField
              value={referrerPhoneNumber}
              onChange={handleReferralInputChanges}
              error={errorsPatientDetails?.referrerPhoneNumber}
              placeholder="Provider's phone number"
              name="referrerPhoneNumber"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default MedicalReferralSection;
